export default function () {
  return {
    init () {
      this.btns = [...document.querySelectorAll('.js-scroll-to')]
      if (this.btns.length) {
        this.setup()
      }
    },
    setup () {
      this.btns.forEach(x => {
        x.addEventListener('click', e => {
          e.preventDefault()
          if (x.nodeName === 'BUTTON') {
            this.scrollTo(document.querySelector(x.getAttribute('data-href')))
          } else {
            this.scrollTo(document.querySelector(x.getAttribute('href')))
          }
        })
      })
    },
    scrollTo (el) {
      const top =
        el.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top
      window.scroll({ top, left: 0, behavior: 'smooth' })
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core/scrollto.js